var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
export default {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        return (__assign({ display: 'inline-block', verticalAlign: 'middle', width: (props.fluid && '100%') || variables.width, height: variables.height || 'auto' }, (props.circular && { borderRadius: pxToRem(9999) }), (props.avatar && {
            width: (props.fluid && '100%') || variables.avatarSize,
            borderRadius: variables.avatarRadius,
        })));
    },
};
